import React from "react";
import AuthLanding from "../AuthLanding/AuthLanding";

const Login = () => {
  return <AuthLanding />;
};

export default Login;
